export default "https://cdn.questicon.mathletics.com/assets/images/Reasoning-L-2f1eac1b8f0e7904241fdaf80772dbee.png";